<template>

    <div :class="['filter-menu', 'filter-' + name ]">
        <div class="filter-label">
            {{ label }}
        </div>

        <div class="flex-grow-1 position-relative">
            <button @click.prevent="clickFilter" :class="['btn', 'w-100', 'btn-filter', {
                active: open, disabled: disabled}]">{{ display }}</button>
            <filter-dialog v-if="open" :name="name" :size="sizeClass">

                <p v-if="disabled" class="disclaimer text-muted">Can't select {{ label }} while filtering by building.</p>

                <div class="filter-content filter-multi">
                <div v-for="opt in options" :key="opt.id" class="custom-control custom-checkbox">

                    <input
                        type="checkbox"
                        :id="optionId(opt.id)"
                        :value="opt.id"
                        v-model.number="selectedArray"
                        class="custom-control-input"
                        :disabled="disabled"
                    >

                    <label class="custom-control-label" :for="optionId(opt.id)">{{ opt.name }}</label>
                </div>
                </div>

            </filter-dialog>
        </div>
    </div>

</template>

<script>

import FilterMixin from '@/mls-filter/mixins/FilterMixin.js';

export default {

    mixins: [FilterMixin],

    props: {
        disabled: Boolean,
        selected: null,
        numeric: Boolean,
    },

    computed: {

        selectedArray: {
            get() {
                return this.$store.state.selected[this.name];
            },
            set(value) {
                this.$store.dispatch('applyFilterMulti', {
                    filter: this.name,
                    value,
                });
            },
        },

        display() {

            switch (this.selectedArray.length) {
                case 0:
                    return 'All ' + this.defaultLabel + 's';
                case 1:
                    return this.getOption(this.selectedArray[0]).name;
                default:
                    return this.selectedArray.length + ' ' + this.defaultLabel + 's';
            }
        },
    },

    methods: {

    },
};

</script>

